export const getLocalOffsetMs = () => new Date().getTimezoneOffset() * -60000;
export const getOffsetDate = (timestamp, offsetS) => {
    const timestampMs = new Date(timestamp).getTime();
    return new Date(timestampMs + (offsetS * 1000 - getLocalOffsetMs()));
};
export const isToday = (date, offsetS) => date.getDay() === getOffsetDate(new Date().getTime(), offsetS).getDay();
